package dev.lingvo.site.pages.app.projects.slug.screenshots

import dev.lingvo.shared.ShotExportKind
import dev.lingvo.shared.StorePlatform

fun exportDownloadFilename(platform: StorePlatform, kind: ShotExportKind, approvedSet: Boolean): String =
    "${platform.id}-${kind.name.lowercase()}-fastlane-${if (approvedSet) "approved" else "unreviewed"}.zip"

/** Reads only STORED local entries, the server's export contract. Unknown ZIP shapes remain unreviewed. */
fun exportManifestText(bytes: ByteArray): String? {
    fun u16(at: Int): Int = (bytes[at].toInt() and 255) or ((bytes[at + 1].toInt() and 255) shl 8)
    fun u32(at: Int): Long = (0..3).sumOf { (bytes[at + it].toLong() and 255) shl (8 * it) }
    var offset = 0
    repeat(2000) {
        if (offset.toLong() + 30 > bytes.size || u32(offset) != 0x04034b50L) return null
        if (u16(offset + 6) and 9 != 0 || u16(offset + 8) != 0) return null
        val size = u32(offset + 18)
        val nameStart = offset + 30
        val nameEnd = nameStart.toLong() + u16(offset + 26)
        val bodyStart = nameEnd + u16(offset + 28)
        val end = bodyStart + size
        if (end > bytes.size || size != u32(offset + 22)) return null
        val name = bytes.copyOfRange(nameStart, nameEnd.toInt()).decodeToString()
        if (name == "manifest.json") {
            if (size > 2 * 1024 * 1024) return null
            return bytes.copyOfRange(bodyStart.toInt(), end.toInt()).decodeToString()
        }
        offset = end.toInt()
    }
    return null
}
